/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_HEADER_PRICE_DETAILS = 'GET_HEADER_PRICE_DETAILS';
export const GET_PRICE_GRID_DETAILS = 'GET_PRICE_GRID_DETAILS';
export const GET_MANUFACTURER_LIST = 'GET_MANUFACTURER_LIST';
export const GET_DRUG_FAMILIES = 'GET_DRUG_FAMILIES';
export const GET_PAGE_COUNT = 'GET_PAGE_COUNT';
export const GET_PLANTYPE_DESCRIPTION = 'GET_PLANTYPE_DESCRIPTION';
export const CLEAR_SEARCH_REDUX = 'CLEAR_SEARCH_REDUX';
export const SET_SELECTED_DRUG = 'SET_SELECTED_DRUG';
export const STORE_UPDATED_PAGE = 'STORE_UPDATED_PAGE';
export const SAVE_PRICE_DETAILS = 'SAVE_PRICE_DETAILS';
export const PRICE_DETAIL_ERRORS = 'PRICE_DETAIL_ERRORS';
export const SHOW_ALL_QUARTERS = 'SHOW_ALL_QUARTERS';
export const DELETED_UPDATED_ROW = 'DELETED_UPDATED_ROW';
export const STORE_BLUR_STATE = 'STORE_BLUR_STATE';
export const STORE_OVERLAP_STATE_ERR = 'STORE_OVERLAP_STATE_ERR';
export const STORE_REBATE_PRICE_DETAILS = 'STORE_REBATE_PRICE_DETAILS';
export const PRICE_DETAILS_ERRORS = 'PRICE_DETAILS_ERRORS';
export const PRICE_LEVEL_GET_REBATE_PGMS = 'PRICE_LEVEL_GET_REBATE_PGMS';
export const STORE_UPDATED_LIST = 'STORE_UPDATED_LIST';
export const REBET_PRICE_LEVEL_SEARCH_INPUT_DATA =
  'REBET_PRICE_LEVEL_SEARCH_INPUT_DATA';
export const UPDATED_PAGE = 'UPDATED_PAGE';
export const MFG_ID = 'MFG_ID';
export const ERROR_CONTROL = 'ERROR_CONTROL';
export const UPDATE_MAINTAIN_PRICE_DETAILS = 'UPDATE_MAINTAIN_PRICE_DETAILS';
export const STORE_ALL_LIST = 'STORE_ALL_LIST';
export const ONCHANGE_PAYLOAD = 'ONCHANGE_PAYLOAD';
